import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useUnitLinks } from 'core/contexts/unitLinks';
import { Field, Form, FormSpy } from 'react-final-form';
import { Grid2, InputAdornment } from '@mui/material';
import { SelectCheckbox, SelectComponent, TextInput } from '@utriper/core-ui';
import { Search } from '@mui/icons-material';
import { UnitType } from '@utriper/core';

const FiltersForm = () => {
    const { i18n, t } = useTranslation();
    const translate = (key) => t(`experience_units.filters.${key}`);
    const { expLinkFilters, setExpLinkFilters, setExpLinkPage } = useUnitLinks();

    const unitTypeOptions = useMemo(
        () =>
            UnitType.getIds().map((id) => ({
                id,
                name: UnitType.getTranslatedName(UnitType.types, id, i18n.language),
            })),
        [i18n.language]
    );

    const isActiveOptions = [
        { id: 'all', name: translate('active_options.all') },
        { id: 'true', name: translate('active_options.active') },
        { id: 'false', name: translate('active_options.inactive') },
    ];

    const handleChangeForm = ({ values }) => {
        setExpLinkFilters({ ...values });
        setExpLinkPage(1);
    };

    return (
        <Form
            onSubmit={() => {}}
            initialValues={{ ...expLinkFilters }}
            render={({ form, handleSubmit, values }) => {
                const handleChangeUnitType = (newUnitType) => {
                    form.change('unitType', [...newUnitType]);
                };

                return (
                    <form onSubmit={handleSubmit} style={{ width: '100%', margin: '16px 0px' }}>
                        <Grid2 container size={12} spacing={2} flexWrap={{ xs: 'wrap', md: 'nowrap' }} sx={{ '& .MuiInputBase-root': { height: '100%' } }}>
                            {/* Search By Name */}
                            <Grid2 container size={{ xs: 12, md: 3 }}>
                                <Field
                                    name="name"
                                    component={TextInput}
                                    label=""
                                    placeholder={translate('name_placeholder')}
                                    slotProps={{
                                        input: {
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search />
                                                </InputAdornment>
                                            ),
                                        },
                                    }}
                                />
                            </Grid2>

                            {/* Unit Type */}
                            <Grid2
                                container
                                size={{ xs: 6, md: 2 }}
                                sx={{
                                    '& .MuiFormControl-root': {
                                        width: '100%',
                                    },
                                }}
                            >
                                <Field name="unitType" component={SelectCheckbox} options={unitTypeOptions} label={translate('unit_type_label')} values={values?.unitType ?? []} onChange={handleChangeUnitType} />
                            </Grid2>

                            {/* Is Active */}
                            <Grid2 container size={{ xs: 6, md: 2 }}>
                                <Field name="isActive" component={SelectComponent} values={isActiveOptions} label={translate('is_active_label')} />
                            </Grid2>
                        </Grid2>

                        {/* Form Spy */}
                        <FormSpy subscription={{ values: true }} onChange={handleChangeForm} />
                    </form>
                );
            }}
        />
    );
};

export default FiltersForm;
